import { usePathname } from 'expo-router'
import { useEffect, useRef } from 'react'
import { Platform } from 'react-native'

const scrollPositions = new Map<string, number>()

export function useScrollRestoration() {
  const pathname = usePathname()
  const pathnameRef = useRef(pathname)

  useEffect(() => {
    if (Platform.OS !== 'web') return

    function handleScroll() {
      scrollPositions.set(pathnameRef.current, window.scrollY)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    if (Platform.OS !== 'web') return

    pathnameRef.current = pathname

    const saved = scrollPositions.get(pathname)
    if (saved != null) {
      requestAnimationFrame(() => window.scrollTo(0, saved))
    } else {
      window.scrollTo(0, 0)
    }
  }, [pathname])
}
